export default __webpack_public_path__ + "locales/pt-BR/Notifications.json?hash=af0edec20281587bf0f2c8b4adb13178";